import {CustomDomain, CustomDomainRequest} from '../../types/organization/CustomDomain';
import {nFetch} from '../../nFetch';
import {trackPromise} from '../../../actions/pure/util';
import {ErrorTags, EventNames} from '../../../lib/analytics/events';

export abstract class CustomDomainCrud {
    abstract orgId: string;

    abstract list(): Promise<CustomDomain[]>;

    abstract get(hostname: string): Promise<CustomDomain>;

    abstract add(src: CustomDomainRequest): Promise<CustomDomain>;

    abstract verify(hostname: string): Promise<CustomDomain>;

    abstract update(src: CustomDomainRequest): Promise<CustomDomain>;

    abstract delete(hostname: string): Promise<undefined>;
}

export class CrudImpl extends CustomDomainCrud {
    orgId: string;

    constructor(orgId: string) {
        super();
        this.orgId = orgId;
    }

    async list() {
        const req = nFetch<CustomDomain[]>(`/organization/${this.orgId}/custom_domains`).then((res) => {
            if (!!res.error) throw res.error;
            return res.data!;
        });
        return trackPromise(req, EventNames.ORG_LIST_CUSTOM_DOMAINS_SUCCESS, ErrorTags.ORG_LIST_CUSTOM_DOMAINS_ERROR);
    }

    async get(hostname: string) {
        const req = nFetch<CustomDomain>(`/organization/${this.orgId}/custom_domains/${hostname}`).then((res) => {
            if (!!res.error) throw res.error;
            return res.data!;
        });
        return trackPromise(req, EventNames.ORG_GET_CUSTOM_DOMAIN_SUCCESS, ErrorTags.ORG_GET_CUSTOM_DOMAIN_ERROR);
    }

    async add(src: CustomDomainRequest) {
        const req = nFetch<CustomDomain>(`/organization/${this.orgId}/custom_domains`, {
            method: 'POST',
            body: JSON.stringify(src),
        }).then((res) => {
            if (!!res.error) throw res.error;
            return res.data!;
        });
        return trackPromise(req, EventNames.ORG_ADD_CUSTOM_DOMAIN_SUCCESS, ErrorTags.ORG_ADD_CUSTOM_DOMAIN_ERROR);
    }

    async verify(hostname: string) {
        const req = nFetch<CustomDomain>(`/organization/${this.orgId}/custom_domains/${hostname}/verify`, {
            method: 'POST',
        }).then((res) => {
            if (!!res.error) throw res.error;
            return res.data!;
        });
        return trackPromise(req, EventNames.ORG_VERIFY_CUSTOM_DOMAIN_SUCCESS, ErrorTags.ORG_VERIFY_CUSTOM_DOMAIN_ERROR);
    }

    async update(src: CustomDomainRequest) {
        const req = nFetch<CustomDomain>(`/organization/${this.orgId}/custom_domains/${src.hostname}`, {
            method: 'PATCH',
            body: JSON.stringify(src),
        }).then((res) => {
            if (!!res.error) throw res.error;
            return res.data!;
        });
        return trackPromise(req, EventNames.ORG_UPDATE_CUSTOM_DOMAIN_SUCCESS, ErrorTags.ORG_UPDATE_CUSTOM_DOMAIN_ERROR);
    }

    async delete(hostname: string) {
        const req = nFetch<undefined>(
            `/organization/${this.orgId}/custom_domains/${hostname}`,
            {
                method: 'DELETE',
            },
            false,
        ).then((res) => {
            if (!!res.error) throw res.error;
            return res.data!;
        });
        return trackPromise(req, EventNames.ORG_DELETE_CUSTOM_DOMAIN_SUCCESS, ErrorTags.ORG_DELETE_CUSTOM_DOMAIN_ERROR);
    }
}
